const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const REFRESH_CSRF_COOKIE_NAME =
  process.env.REACT_APP_AUTH_REFRESH_CSRF_COOKIE_NAME || 'csrf_refresh_token';

function readSession(key: string): string {
  try {
    return String(sessionStorage.getItem(key) || '').trim();
  } catch {
    return '';
  }
}

function readLocal(key: string): string {
  try {
    return String(localStorage.getItem(key) || '').trim();
  } catch {
    return '';
  }
}

function writeSession(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

function removeSession(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

function removeLocal(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

function migrateLegacyToken(key: string): string {
  const current = readSession(key);
  if (current) return current;
  const legacy = readLocal(key);
  if (!legacy) return '';
  writeSession(key, legacy);
  removeLocal(key);
  return legacy;
}

export function getStoredAccessToken(): string {
  return migrateLegacyToken(ACCESS_TOKEN_KEY);
}

export function getStoredRefreshToken(): string {
  return migrateLegacyToken(REFRESH_TOKEN_KEY);
}

export function storeAuthTokens(accessToken: string, refreshToken?: string): void {
  if (String(accessToken || '').trim()) {
    writeSession(ACCESS_TOKEN_KEY, String(accessToken).trim());
    removeLocal(ACCESS_TOKEN_KEY);
  }
  if (String(refreshToken || '').trim()) {
    writeSession(REFRESH_TOKEN_KEY, String(refreshToken).trim());
    removeLocal(REFRESH_TOKEN_KEY);
  }
}

export function storeAccessTokenOnly(accessToken: string): void {
  if (String(accessToken || '').trim()) {
    writeSession(ACCESS_TOKEN_KEY, String(accessToken).trim());
    removeLocal(ACCESS_TOKEN_KEY);
  }
  removeSession(REFRESH_TOKEN_KEY);
  removeLocal(REFRESH_TOKEN_KEY);
}

export function getRefreshCsrfToken(): string {
  try {
    const cookieSource = String(document.cookie || '');
    const target = `${REFRESH_CSRF_COOKIE_NAME}=`;
    const match = cookieSource
      .split(';')
      .map((chunk) => chunk.trim())
      .find((chunk) => chunk.startsWith(target));
    if (!match) return '';
    return decodeURIComponent(match.slice(target.length)).trim();
  } catch {
    return '';
  }
}

export function hasBrowserRefreshSession(): boolean {
  return Boolean(getRefreshCsrfToken());
}

export function clearAuthTokens(): void {
  removeSession(ACCESS_TOKEN_KEY);
  removeSession(REFRESH_TOKEN_KEY);
  removeLocal(ACCESS_TOKEN_KEY);
  removeLocal(REFRESH_TOKEN_KEY);
}
